import translations from '../localization/translations';
import { API_ERROR_TRANSLATIONS } from '../localization/apiErrorTranslations';
import { resolveLanguage } from '../store/services/http-common';
import { resolveApiMessageKey } from '../localization/apiMessageCatalog';

export function translateApiMessage(message, language = resolveLanguage()) {
  if (message == null || message === '') {
    return message;
  }

  const key = resolveApiMessageKey(message);
  if (!key) {
    return message;
  }

  const localized =
    API_ERROR_TRANSLATIONS[language]?.[key]
    ?? translations[language]?.[key]
    ?? (language !== 'en'
      ? (API_ERROR_TRANSLATIONS.en?.[key] ?? translations.en?.[key])
      : null);

  return localized ?? message;
}

export function translateApiMessages(messages, language = resolveLanguage()) {
  if (!Array.isArray(messages)) {
    return [];
  }

  return messages.map((message) => translateApiMessage(message, language));
}

export function translateFieldErrors(errors, language = resolveLanguage()) {
  if (!errors || typeof errors !== 'object') {
    return errors;
  }

  return Object.fromEntries(
    Object.entries(errors).map(([field, fieldErrors]) => [
      field,
      (Array.isArray(fieldErrors) ? fieldErrors : [fieldErrors]).map((message) =>
        translateApiMessage(message, language),
      ),
    ]),
  );
}
